export const getUTCDate = (value?: string): string => {
  if (!value) return '';

  const date = new Date(value ?? '');

  return new Date(Date.UTC(date?.getFullYear(), date?.getMonth(), date?.getDate())).toISOString();
};
